import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jswConfigHeaderSpork: {
		id: 'products-jsw-configuration-main.jsw-config-header.jsw-config-header-spork',
		defaultMessage: 'Software project configuration',
		description: 'Header of Jira Software Configuration page',
	},
});
